import { render, staticRenderFns } from "./ExpertApplyForAudit.vue?vue&type=template&id=90ffe3ae&scoped=true"
import script from "./ExpertApplyForAudit.vue?vue&type=script&lang=js"
export * from "./ExpertApplyForAudit.vue?vue&type=script&lang=js"
import style0 from "./ExpertApplyForAudit.vue?vue&type=style&index=0&id=90ffe3ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ffe3ae",
  null
  
)

export default component.exports